import React from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import clsx from 'clsx'
import IconButton from '@material-ui/core/IconButton'
import Link from '@material-ui/core/Link'
import Button from '@material-ui/core/Button'
import DeleteIcon from '@material-ui/icons/Delete'
import Box from '@material-ui/core/Box'
import { FormattedMessage } from 'react-intl'
import messages from '../../messages'
import { configContext } from '../../products/DnaPlates/DnaPlates'
import { EmptyState } from '../../products/DnaPlates/Reducer'
import ViewAllDialogForPlate from '@src/routes/Configurators/components/ViewAllDialogForPlate'
import DeleteAllDialog from '../DeleteDialog'
import { useRouter, dnaPlatesRoute } from '@src/routes'
import {
  ActiveLinkTypeDnaplate,
  PlateProduct,
  CountryCodes,
  USExportCountriesListFor384Well,
  minimumWellsExecptionCountries,
  Specifications,
  australianCountries,
} from '../../products/DnaPlates/enum'
import { usePlateSessionFieldMutation } from '@src/mutations/ConfiguratorTubesMutation.generated'
import ErrorIcon from '@material-ui/icons/Error'
import { isIEBrowser } from '../../utils/util'

const useStyles = makeStyles((theme: Theme) => ({
  listContainer: {
    margin: theme.spacing(4, 0),
  },
  scroll: {
    overflow: 'auto',
    height: theme.spacing(60),
  },
  view: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  viewAll: {
    justifyContent: 'flex-end',
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.primary.main,
    margin: theme.spacing(0),
    '&:hover': {
      backgroundColor: 'inherit',
      color: theme.palette.primary.dark,
    },
  },
  bottonText: {
    padding: theme.spacing(0, 1, 0, 0),
  },
  buttonTextIe: {
    padding: theme.spacing(0, 3, 0, 0),
  },
  labelRoot: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.grey[500],
    overflowWrap: 'break-word',
  },
  button: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.primary.main,
    padding: theme.spacing(1),
    '&:hover': {
      backgroundColor: 'inherit',
      color: theme.palette.primary.dark,
    },
  },
  delete: {
    padding: theme.spacing(0),
    float: 'right',
  },
  divider: {
    margin: theme.spacing(1),
  },
  active: {
    borderBottom: `2px solid ${theme.palette.primary.main}`,
    fontWeight: theme.typography.fontWeightMedium,
    '& $activeLabel': {
      color: theme.palette.primary.main,
    },
  },
  header: {
    marginBottom: theme.spacing(5),
  },
  heading: {
    fontSize: theme.typography.pxToRem(22),
    fontWeight: theme.typography.fontWeightRegular,
  },
  errorIcon: {
    padding: theme.spacing(0),
    color: theme.palette.rich.red,
    verticalAlign: 'top',
  },
  listIcon: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  deleteIcon: {
    fontSize: theme.typography.pxToRem(22),
    color: theme.palette.grey[400],
  },
  activeLabel: {},
}))

const DnaplateProductsSummary = (props) => {
  const { productDetails } = props
  const classes = useStyles()
  const [dialogOpen, setDialogOpen] = React.useState(false)
  const [deldialogOpen, setDeldialogOpen] = React.useState(false)
  const { state, dispatch } = React.useContext(configContext)
  const [platesessionField] = usePlateSessionFieldMutation()
  const { sessionData } = state
  const data = sessionData
  const [delItems, setDelItems] = React.useState()
  const router = useRouter()
  const isIE = isIEBrowser()
  const [index, setIndex] = React.useState(state.currentPlateIndex)
  const savePlateDataToSession = async (obj) => {
    await platesessionField({
      variables: { input: obj, productInput: productDetails },
    })
  }

  React.useEffect(() => {
    state.currentPlateIndex = index
    dispatch({
      type: 'UPDATE_CURRENT_PLATE_INDEX',
      data: state.currentPlateIndex,
    })
    // TODO: need a test before we refactor these dependencies
  }, [index])

  const minimumWells = (data) => {
    let minimumWells = false
    if (state.minimumWellsError && sessionData[0].isOverridden !== true) {
      if (productDetails.productType === PlateProduct.DuplexPlate) {
        if (data.biTubeWellList.length < 24) {
          minimumWells = true
        }
      } else {
        if (
          !(
            (data.wellType === PlateProduct.wellType &&
              USExportCountriesListFor384Well.includes(
                productDetails.countryCode
              )) ||
            minimumWellsExecptionCountries.includes(productDetails.countryCode)
          )
        ) {
          if (productDetails.countryCode === CountryCodes.JP) {
            if (
              (data.plateType === Specifications.STANDARD &&
                data.wellList.length < 48) ||
              (data.plateType === Specifications.MIXED &&
                data.wellList.length < 96)
            ) {
              minimumWells = true
            }
          } else if (australianCountries.includes(productDetails.countryCode)) {
            if (
              (data.plateType === Specifications.STANDARD &&
                data.wellList.length < 40) ||
              (data.plateType === Specifications.MIXED &&
                data.wellList.length < 80)
            ) {
              minimumWells = true
            }
          } else {
            if (
              (data.plateType === Specifications.STANDARD &&
                data.wellList.length < 24) ||
              (data.plateType === Specifications.MIXED &&
                data.wellList.length < 48)
            ) {
              minimumWells = true
            }
          }
        }
      }
    }

    return minimumWells
  }

  const deletePlate = (item, type) => {
    if (type === 'Selected' && sessionData.length !== 1) {
      let idChanged = false
      if (
        item.plateId - 1 === state.currentPlateIndex &&
        sessionData.length - 1 === state.currentPlateIndex &&
        sessionData.length !== 1
      ) {
        dispatch({
          type: 'UPDATE_CURRENT_PLATE_INDEX',
          data: state.currentPlateIndex - 1,
        })
      }
      sessionData.forEach((plate) => {
        if (plate.plateId > item.plateId) {
          plate.plateId = plate.plateId - 1
          idChanged = true
        }
      })
      const index = sessionData.indexOf(item)
      if (index !== -1) {
        sessionData.splice(index, 1)
      }
      sessionData.forEach((data) => {
        data.pageNo = 1
        let errorExist = false
        if (
          data.plateNameError.length !== 0 ||
          data.researcherNameError.length !== 0
        ) {
          errorExist = true
        } else if (minimumWells(data)) {
          errorExist = true
        } else if (productDetails.productType === PlateProduct.DuplexPlate) {
          data.biTubeWellList.forEach((duplexwell) => {
            if (duplexwell.listError.length !== 0) {
              errorExist = true
            }
          })
        } else {
          data.wellList.forEach((well) => {
            if (well.listError.length !== 0) {
              errorExist = true
            }
          })
        }
        if (!errorExist) dispatch({ type: 'SET_PAGE_ERROR', data: '' })
      })

      if (idChanged) {
        dispatch({
          type: 'IS_PLATE_DELETED',
          data: !state.isPlateDeleted,
        })
      }
      dispatch({
        type: 'SET_STEP_NO',
        data: 1,
      })
      dispatch({
        type: 'UPDATE_INPUT',
        data: [...state.sessionData],
      })
      savePlateDataToSession(sessionData)
      setDialogOpen(false)
      window.scrollTo(0, 0)
    } else if (sessionData.length === 1 || type === 'All') {
      if (sessionData.length === 1 || type === 'All') {
        sessionData.splice(0, sessionData.length)
      }
      state.sessionData.push(EmptyState)
      sessionData.forEach((data) => {
        delete data.__typename
        data.wellList.forEach((well) => {
          delete well.__typename
        })
        data.biTubeWellList.forEach((duplexwell) => {
          delete duplexwell.__typename
        })
      })
      //remove error directly as no more plates present
      dispatch({ type: 'SET_PAGE_ERROR', data: '' })
      dispatch({
        type: 'UPDATE_CURRENT_PLATE_INDEX',
        data: 0,
      })
      dispatch({
        type: 'UPDATE_INPUT',
        data: [...state.sessionData],
      })
      savePlateDataToSession([])
      setDialogOpen(false)
      dispatch({
        type: 'SET_STEP_NO',
        data: 0,
      })
      const url = `${dnaPlatesRoute.index()}?product=${
        productDetails.productType
      }&activeLink=${ActiveLinkTypeDnaplate.SequenceUpload}`
      router.push(url)
    }
    window.scrollTo(0, 0)
  }

  const handleDelete = (item) => {
    setDeldialogOpen(true)
    setDelItems(item)
  }

  const renderData = () => {
    const result: any[] = []
    data.forEach((item, index) => {
      let error = 0
      if (
        item.plateNameError.length !== 0 ||
        item.researcherNameError.length !== 0
      ) {
        error = error + 1
      }
      if (minimumWells(item)) {
        error = error + 1
      }

      if (productDetails.productType === PlateProduct.DuplexPlate) {
        item.biTubeWellList.forEach((duplexwell) => {
          if (duplexwell.listError.length !== 0) {
            error = error + 1
          }
        })
      } else {
        item.wellList.forEach((well) => {
          if (well.listError.length !== 0) {
            error = error + 1
          }
        })
      }

      result.push(
        <Grid
          container
          alignItems="flex-end"
          className={classes.listContainer}
          key={index}
        >
          <Grid item sm={1} className={classes.listIcon}>
            <img alt="hexes" src="/static/hexes.png" />
          </Grid>
          <Grid
            item
            sm={10}
            className={clsx(
              item.plateId === state.currentPlateIndex + 1 && classes.active
            )}
          >
            <div>
              <Link
                href="#"
                onClick={() => setIndex(index)}
                className={clsx(
                  classes.labelRoot,
                  item.plateId === state.currentPlateIndex + 1 &&
                    classes.activeLabel
                )}
              >
                {item.plateName}
              </Link>
              {error > 0 ? (
                <ErrorIcon fontSize="small" className={classes.errorIcon} />
              ) : (
                ''
              )}
            </div>
          </Grid>
          <Grid item sm={1}>
            <IconButton
              aria-label="delete"
              className={classes.delete}
              onClick={() => {
                handleDelete(item)
              }}
            >
              <DeleteIcon className={classes.deleteIcon} />
            </IconButton>
          </Grid>
        </Grid>
      )
    })
    return result
  }
  return (
    <>
      <Box mt={50}>
        <Grid
          container
          alignItems="flex-end"
          className={classes.header}
          justify="center"
        >
          <Grid item xs={12} sm={6}>
            <h3 className={classes.heading}>
              <FormattedMessage {...messages.CONF_MY_PLATES_SIDE_BAR} />
            </h3>
          </Grid>
          <Grid item xs={12} sm={6} className={classes.view}>
            <Button
              className={clsx(
                classes.viewAll,
                isIE ? classes.buttonTextIe : classes.bottonText
              )}
              onClick={() => setDialogOpen(true)}
            >
              <FormattedMessage {...messages.CONF_VIEW_ALL_SIDE_BAR} />
            </Button>
          </Grid>
        </Grid>
        <Grid className={data.length > 6 ? classes.scroll : ''}>
          {renderData()}
        </Grid>
      </Box>
      <ViewAllDialogForPlate
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        viewAllItems={sessionData}
        onDelete={deletePlate}
      />
      <DeleteAllDialog
        dialogOpen={deldialogOpen}
        setDialogOpen={setDeldialogOpen}
        type="Selected"
        selectedItem={delItems}
        onDelete={deletePlate}
      />
    </>
  )
}

export default DnaplateProductsSummary
